import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getCookie } from '@beef/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchData } from "./index";
import { selectCartApiUrl, selectCartCookieName, selectCartHref, selectCartQuantityUrl, selectCartShouldInitialize } from "./selectors";
export var fetchQuantity = createAsyncThunk('cart/createRequest', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, dispatch, cartBaseUrl, quantityUrl, shouldInitialize, cartId, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, dispatch = _ref.dispatch;
          cartBaseUrl = selectCartApiUrl(getState());
          quantityUrl = selectCartQuantityUrl(getState());
          shouldInitialize = selectCartShouldInitialize(getState());
          cartId = getCookie(selectCartCookieName(getState()));
          if (cartBaseUrl && quantityUrl && cartId && shouldInitialize) {
            url = "".concat(cartBaseUrl, "/").concat(quantityUrl, "/").concat(cartId); // eslint-disable-next-line @typescript-eslint/no-floating-promises
            dispatch(fetchData(url));
          }
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
export var handleClickCart = createAsyncThunk('cart/createRequest', function (_, _ref3) {
  var getState = _ref3.getState;
  var href = selectCartHref(getState());
  if (href) {
    window.location.href = href;
  }
});